/** Shift+Enter promotes to long mode; when already long, Shift+Enter inserts a newline. */
export function handleNoteTitleKeyDown(
	event: React.KeyboardEvent<HTMLInputElement | HTMLTextAreaElement>,
	options: { isLong: boolean; onPromoteToLong: () => void },
) {
	if (event.key !== 'Enter' || !event.shiftKey || options.isLong) {
		return;
	}
	event.preventDefault();
	options.onPromoteToLong();
}
